import { useState } from "react";
import { ref, uploadBytes, getDownloadURL } from "firebase/storage";
import { updateDoc, doc } from "firebase/firestore";
import { storage, db } from "../../services/firebase/config";
import { Button, IconButton } from "@mui/material";
import PhotoCamera from "@mui/icons-material/PhotoCamera";

function ProfileImageUpdate({ userId, onImageUpdate }) {
  const [uploading, setUploading] = useState(false);

  const handleImageUpload = async (event) => {
    const file = event.target.files[0];
    if (!file) return;

    // Add file size validation (5MB limit)
    const MAX_FILE_SIZE = 5 * 1024 * 1024; // 5MB in bytes
    if (file.size > MAX_FILE_SIZE) {
      alert('Image size must be less than 5MB');
      return;
    }

    try {
      setUploading(true);
      const storageRef = ref(storage, `profile-images/${userId}`);
      await uploadBytes(storageRef, file);
      const downloadURL = await getDownloadURL(storageRef);

      // Update user profile in Firestore
      const userRef = doc(db, "users", userId);
      await updateDoc(userRef, {
        photoURL: downloadURL
      });

      onImageUpdate(downloadURL);
      alert("Profile image updated successfully!");
    } catch (error) {
      console.error("Error uploading image:", error);
      alert("Error uploading image: " + error.message);
    } finally {
      setUploading(false);
    }
  };

  return (
    <IconButton
      color="primary"
      aria-label="upload picture"
      component="label"
      disabled={uploading}
    >
      <input
        hidden
        accept="image/*"
        type="file"
        onChange={handleImageUpload}
      />
      <PhotoCamera />
    </IconButton>
  );
}

export default ProfileImageUpdate;